import React, { useCallback, useEffect, useState, useContext } from 'react';
import { filterNotHiddenItem, getTernaryValue } from 'common/utilities/utils';

import {
  checkCategoryAvailability,
  getDynamicMenuAlertType,
  getCheckTimeSpecificCategoryAvailability,
} from 'molecules/DynamicMenuAlert/AU/Utils/DynamicMenuAlertUtils';
import {
  menuNavigationAnalyticsData,
  menuNavigation,
  setFirstCategoryActive,
  changeMenulistOrder,
} from '../MenusPlpUtilities/MenusPlpUtils';
import { Link, scroller } from 'react-scroll';
import { DYNAMIC_MENU_CONSTANTS, ROUTE_URL } from 'common/constants/SharedConstants';
import { UserOrderContext } from 'context/context';
import { getStoreDetails } from 'organisms/HeaderComponent/AU/HeaderUtilities/HeaderUtils';
import { useSelector } from 'react-redux';
import { getValueOrDefaultObject } from '../../../../common/utilities/utils';

const getClassName = isMobile => {
  return isMobile ? 'mob-outer-ul' : 'outer-ul';
};

const getUpdateInitialHover = (history, setIntialHover) => {
  if (history?.location?.pathname === ROUTE_URL.CATERING_PAGE || ROUTE_URL.MENU_PAGE) {
    setIntialHover(true);
  }
};

const MenuLink = ({
  isMobile,
  menu,
  categories,
  setActiveMenuSelection,
  history,
  hasSubcategory,
  handleSetActive,
  getMenusSubcategory,
  onItemClick,
}) => {
  const setFirstCategoryActiveMemoized = useCallback(
    (
      e,
      index,
      name,
      url,
      filterNotHiddenItem,
      categories,
      scroller,
      menuNavigationAnalyticsData,
      setActiveMenuSelection,
      history,
    ) => {
      setFirstCategoryActive(
        e,
        index,
        name,
        url,
        filterNotHiddenItem,
        categories,
        scroller,
        menuNavigationAnalyticsData,
        setActiveMenuSelection,
        history,
      );
    },
    [],
  );
  const storeData = useSelector(data => getValueOrDefaultObject(data.storesReducer));
  const getUpdateStoreDetails = () => {
    return storeData?.storesWithStatus && getStoreDetails(storeData?.storesWithStatus[0]);
  };
  const getStoreDetail = getUpdateStoreDetails();
  const updatedMenuData = menu?.length && changeMenulistOrder(menu);
  const filteredItems = updatedMenuData?.length && filterNotHiddenItem(updatedMenuData);
  const [intialHover, setIntialHover] = useState(false);
  const { userOrderState, userOrderStateDispatch } = useContext(UserOrderContext);
  const { timeBasedCetegory, timeBasedAlertModalData } = userOrderState;
  const { menuReducer } = useSelector(data => data);
  useEffect(() => {
    getUpdateInitialHover(history, setIntialHover);
  }, [history]);

  const setActiveClass = (param, id) => {
    setIntialHover(false);
    handleSetActive(param, id);
  };
  const checkItemExpiry = name => {
    if (timeBasedCetegory?.timeDifference && !timeBasedAlertModalData?.isReviewOrderClick) {
      return false;
    }
    const item = { categoryName: name };
    return getCheckTimeSpecificCategoryAvailability({ item, getStoreDetail, menuReducer, showModal: false });
  };
  const onClickHandler = (event, name, url, index) => {
    event?.stopPropagation();
    event?.preventDefault();
    const itemExpried = checkCategoryAvailability(
      {
        categoryUrl: url,
        itemInCart: timeBasedCetegory?.timebasedItemInCart,
        alertType: getDynamicMenuAlertType(timeBasedCetegory?.timebasedItemInCart, DYNAMIC_MENU_CONSTANTS?.CATEGORY),
      },
      timeBasedCetegory,
      userOrderStateDispatch,
    );
    if (itemExpried) {
      return;
    }

    if (isMobile) {
      menuNavigation(name?.trim(), url, history);
    } else {
      setFirstCategoryActiveMemoized(
        event,
        index,
        name?.trim(),
        url,
        filterNotHiddenItem,
        categories,
        scroller,
        menuNavigationAnalyticsData,
        setActiveMenuSelection,
        history,
      );
    }
  };
  return (
    <ul className={getClassName(isMobile)}>
      {filteredItems?.length &&
        filteredItems.map(({ id, isHidden, url, name, dname, categories: categoryData }, index) => {
          return (
            !isHidden &&
            !checkItemExpiry(name) && (
              <li key={index} id={`category-name-${id}`}>
                <Link
                  data-testid='category-click-test'
                  to={name.trim()}
                  onClick={event => onClickHandler(event, name, url, index)}
                  spy={true}
                  offset={getTernaryValue(isMobile, -120, -130)}
                  smooth={true}
                  duration={1500}
                  delay={100}
                  activeClass={getTernaryValue(isMobile, 'active', null)}
                  className={`${intialHover && index === 0 && 'active'} ${
                    !isMobile && `${hasSubcategory(categoryData) ? 'caret' : ''}`
                  }`}
                  onSetActive={param => setActiveClass(param, id)}
                >
                  {dname[0].value}
                </Link>
                {!isMobile && getMenusSubcategory(categoryData || [], handleSetActive, onItemClick)}
              </li>
            )
          );
        })}
    </ul>
  );
};

export default React.memo(MenuLink);
